import "./style.scss";

import { Col, Row } from "@amzn/stencil-react-components/layout";
import { PropsWithChildren, ReactNode } from "react";

import {
  centeredStepContentColumnClassName,
  progressRailColumnClassName,
  progressTrackerLayoutClassName,
  stepContentColumnClassName,
} from "@/components/constants";

interface OnboardingPageLayoutProps {
  /**
   * Progress rail rendered in the left column. Optional so callers that do not
   * need one (for example test harnesses or preview pages) can skip it.
   */
  rail?: ReactNode;
}

/**
 * Two column layout for the Day1 onboarding page: progress rail left, step content right.
 *
 * With no rail the left column is omitted rather than rendered empty, because it reserves a fixed
 * width that would push the content off centre. The content is then centred and bounded.
 */
export default function OnboardingPageLayout({
  rail,
  children,
}: PropsWithChildren<OnboardingPageLayoutProps>): JSX.Element {
  const contentClassName = rail
    ? stepContentColumnClassName
    : `${stepContentColumnClassName} ${centeredStepContentColumnClassName}`;

  return (
    <Row
      alignItems="flex-start"
      className={progressTrackerLayoutClassName}
      dataTestId="onboardingPageLayout"
    >
      {rail && (
        <Col
          className={progressRailColumnClassName}
          dataTestId="progressRailColumn"
        >
          {rail}
        </Col>
      )}
      <Col className={contentClassName} dataTestId="stepContentColumn">
        {children}
      </Col>
    </Row>
  );
}
